import StatsPlugin from './stats'
export default StatsPlugin
